const getLanguage = country => {
  const language = country.split('_')[0]
  if (country === 'nl_BE') {
    return 'fr'
  }
  return language
}

export default getLanguage
